import React from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import Header from './Header';
import Footer from './Footer';
import MobileBottomNav from '../MobileBottomNav';
import FloatingLanguageSwitcher from '../FloatingLanguageSwitcher';

interface LayoutProps {
  children: React.ReactNode;
  title?: string;
  description?: string;
}

const Layout: React.FC<LayoutProps> = ({ 
  children, 
  title = 'TN Cakes Bali® - Custom Cakes Made with Love',
  description = 'Creating beautiful, delicious custom cakes for your special moments in Bali. Professional cake designer with years of experience.'
}) => {
  return (
    <HelmetProvider>
      <div className="min-h-screen flex flex-col">
        <Helmet>
          <title>{title}</title>
          <meta name="description" content={description} />
          <meta name="keywords" content="custom cakes, bali cakes, wedding cakes, birthday cakes, cake designer bali" />
          <meta property="og:title" content={title} />
          <meta property="og:description" content={description} />
          <meta property="og:type" content="website" />
          <meta property="og:url" content="https://tncakesbali.com" />
          <script type="application/ld+json">
            {JSON.stringify({
              "@context": "https://schema.org",
              "@type": "LocalBusiness",
              "name": "TN Cakes Bali®",
              "description": description,
              "url": "https://tncakesbali.com",
              "telephone": "+61-0401-461-019",
              "email": "admin@tncakesbali.com",
              "address": {
                "@type": "PostalAddress",
                "streetAddress": "Jl. Dewi Saraswati No.9",
                "addressLocality": "Seminyak",
                "addressRegion": "Bali",
                "addressCountry": "Indonesia"
              },
              "serviceArea": "Bali, Indonesia",
              "priceRange": "$$",
              "sameAs": [
                "https://instagram.com/tncakesbali",
                "https://facebook.com/tncakesbali"
              ]
            })}
          </script>
        </Helmet>
        <Header />
        <main className="flex-grow mobile-safe-bottom md:pb-0">
          {children}
        </main>
        <div className="hidden md:block">
          <Footer />
        </div>
        <MobileBottomNav />
        <FloatingLanguageSwitcher />
      </div>
    </HelmetProvider>
  );
};

export default Layout;
